import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

const CardContainerDraggable = SortableContainer(({ children }) => <React.Fragment>{children}</React.Fragment>);

export default CardContainerDraggable;
